import { useQuery } from "react-query";
import { clearStoredAuth } from "../utils";
import { useNavigate } from "react-router-dom";

import { API_URL } from "../config";

const fetchPpsDetails = async (
  operatorId: number,
  flightId: number
): Promise<OpsPpsDetailsResponse> => {
  const res = await fetch(
    `${API_URL}/ops/pps/operators/${operatorId}/flights/${flightId}/details`,
    {
      credentials: "include",
    }
  );

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

const useOpsPpsDetails = (
  operatorId: number | null,
  flightId: number | null,
  enabled: boolean
) => {
  const navigate = useNavigate();

  return useQuery<OpsPpsDetailsResponse, Error>(
    ["opsPpsDetails", operatorId, flightId],
    () => fetchPpsDetails(operatorId as number, flightId as number),
    {
      enabled: Boolean(enabled && operatorId && flightId),
      refetchOnWindowFocus: false,
      retry: 1,
      onError: (error: Error) => {
        if (error.message === "401") {
          clearStoredAuth();
          navigate("/");
        }
      },
    }
  );
};

export default useOpsPpsDetails;
